exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-result{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.ebx-result,.ebx-result__footer,.ebx-result__header{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
